const jquery = $;

jquery(document).ready(() => {
  $(document).previewUploadedImage('#app_composition_image');
});
